<div class="container-fluid p-0">
    <mat-card class="card mb-3 profile-common-card-container ">
        <div class="ml-3 normal-text">
            <span class="delete-text">{{'Deletingyouraccount'|translate}}</span>
            <ul class=" normal-text listItems">
                <li>{{'CompletelyList1'|translate}}</li>
                <li *ngFor="let option of subscripeAppList">{{'Removeyouraccess'|translate}}{{option?.appName}} ({{option?.appCountry}})</li>
                <li>{{'Erasedetails'|translate}}</li>
                <li>{{'Youretrieveagain'|translate}}</li>
            </ul>
        </div>
        <div class="row ml-2">
            <div class="col-12">
                <div class="form-group">
                    <div class="input-icon">
                        <section>
                            <div class="input-icon">
                                <mat-checkbox (change)="getChanges($event)">
                                    {{'deletemyaccount'|translate}}
                                </mat-checkbox>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="hideAll">
            <div class="py-3" *ngIf="otpView">
                <mat-divider></mat-divider>
            </div>
            <div class="col-12 m-0 row mt-2" *ngIf="otpView">
                <div class="col-6">
                    <div class="form-group">
                        <label> {{'EnterOnePassword'|translate}}</label>
                        <p>{{'OneTimeEmail'|translate}} {{userInfo?.email}}, {{'PleaseOTPemail'|translate}}</p>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group">
                        <label> {{'Enter your One Time Password (OTP) here'|translate}}</label>
                        <div class="input-icon mt-2">
                            <input type="text" [(ngModel)]="otpval" maxlength="6" #otpModel="ngModel" [ngClass]="{ 'is-invalid':  submitted && otpModel.invalid }" class="form-control title-text" autofocus required>
                            <div *ngIf="submitted && otpModel.errors" class="invalid-feedback">
                                <div *ngIf="otpModel.errors.required">
                                    {{'OTPrequired'|translate}}
                                </div>
                            </div>
                        </div>
                        <p class="float-right mt-1" *ngIf="!showResend"><small> {{'YourequestanotherOTP'|translate}} {{timeLeft}} {{'sec'|translate}}</small></p>
                        <p class="float-right mt-1 resendCls" *ngIf="showResend" (click)="sendOtp()"><small>{{'Resend OTP'|translate}}</small></p>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-12 mt-4" *ngIf="hideAll">
            <div class="form-group text-left">
                <button *ngIf="showButton && submitShow" mat-raised-button type="submit" color="primary" class="card-header-action p-0" (click)="onDelete($event)">{{'DeleteRequest'|translate}}</button>
                <button *ngIf="!submitShow" mat-raised-button type="submit" color="primary" class="card-header-action" (click)="resend()">{{'ConfirmRequest'|translate}}</button>
            </div>
        </div>
    </mat-card>
</div>